import { render, staticRenderFns } from "./el-skeleton-item.vue?vue&type=template&id=33efdf89"
import script from "./el-skeleton-item.vue?vue&type=script&lang=js"
export * from "./el-skeleton-item.vue?vue&type=script&lang=js"
import style0 from "./el-skeleton-item.vue?vue&type=style&index=0&id=33efdf89&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports